import React from 'react';

const PoliticaCookies = () => {
  return (
    <div className="container" style={{ padding: '3rem 0' }}>
      <h1>Política de Cookies</h1>
      
      <h2>¿Qué son las cookies?</h2>
      <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo al navegar por nuestra web.</p>
      
      <h2>¿Qué cookies usamos?</h2>
      <p>Esta web utiliza únicamente:</p>
      <ul>
        <li><strong>Cookies técnicas/esenciales:</strong> Necesarias para el funcionamiento básico de la web.</li>
      </ul>
      <p><strong>No utilizamos cookies de analítica ni de publicidad.</strong></p>
      
      <h2>Gestión de cookies</h2>
      <p>Puedes aceptar o rechazar las cookies no esenciales en el banner. También puedes configurar tu navegador para bloquearlas.</p>
    </div>
  );
};

export default PoliticaCookies;